$(function() {

  $('.success-modals').fadeIn();

  $('.success-stories').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    responsive: [
        {
          breakpoint: 975,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // if ($(window).width() > 1130) {
    $('.success-modals').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      responsive: [
          {
            breakpoint: 975,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true
          }
        }
      ]
    });
  // }
  
});